import React from 'react';
import IMEventEmitter, { IMEvent } from '../../../../net/IMEventEmitter';
import './index.css';

const XIN = require('../../../../images/icons/aixin_icon.png')

const bgc = [
    'linear-gradient(90deg, #878B53, #AEB18C)',
    'linear-gradient(90deg, #C26637, #F7BB87)',
    'linear-gradient(90deg, #8E90B0, #D1D1D1)',
    'linear-gradient(90deg, #DDA610, #E3B249)',
    'linear-gradient(90deg, #6B5BC3, #DBD5FD)',
    'linear-gradient(90deg, #A92BB9, #D596F8)',

]
const LEVEL = ['新秀', '黄铜', '白银', '黄金', '铂金', '钻石']

const vipLevelImg = [
    require('../../../../images/vip/vip_room_1.png'),
    require('../../../../images/vip/vip_room_1.png'),
    require('../../../../images/vip/vip_room_2.png'),
    require('../../../../images/vip/vip_room_3.png'),
    require('../../../../images/vip/vip_room_4.png'),
    require('../../../../images/vip/vip_room_5.png'),
]

//欢迎xxxx进入聊天室
class Marquee extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            content: [],
            index: 0,
            time: 10, //几秒后关闭计时器
            showTime: true,
        };
        this.saveRef = ref => { this.refDom = ref };
    }
    componentDidMount() {
        IMEventEmitter.on(IMEvent.CHAT_ROOM_ZHA, this.onMessageComing, this);

    }
    componentWillUnmount() {
        window.clearInterval(this.timeId)
        IMEventEmitter.off(IMEvent.CHAT_ROOM_ZHA, this.onMessageComing, this);

    }

    //xxx进入了直播间
    onMessageComing = (msgs) => {
        if (msgs.content.length > 11) {
            msgs.content = msgs.content.substr(0, 11);
        }
        let { content } = this.state
        if (msgs.viplevel > 2) {
            msgs.content = '尊贵的' + LEVEL[msgs.viplevel] + msgs.content + '用户'
        }
        content.push(msgs)

        // this.refDom.className = 'marquee-content show';
        this.refDom.style.animation = 'show-item  2s ease-in forwards';
        this.state.time = 10;

        if (this.state.showTime) {
            this.state.showTime = false;
            //计时器开始，10秒后关闭
            this.timeId = setInterval(() => {
                this.state.time--;
                if (this.state.time < 0) {
                    this.refDom.style.animation = 'hide-item  2s ease-in forwards';
                    window.clearInterval(this.timeId)
                    this.state.showTime = true;
                }
            }, 1000);
        }




        //  setTimeout(() => {
        //     //   hide-item
        //      this.refDom.style.animation='hide-item  2s ease-in forwards';
        // }, 1000 * 10)


        this.setState({
            content: content
        })
        this.nextItem()
    }
    nextItem() {
        if (this.state.content.length <= 1) return;
        const { clientHeight } = this.refDom;

        const translateYItem = Math.floor(clientHeight / (this.state.content.length));

        const nextIndex = this.state.index + 1;
        this.refDom.style.transform = `translateY(-${translateYItem * nextIndex}px)`;
        this.refDom.style.transition = 'transform 1s';
        this.setState({
            index: this.state.index + 1
        })
    }
    render() {
        return (
            <div className="marquee-container" >
                <div className="marquee-wrapper">

                    <div className="marquee-content" ref={this.saveRef} >

                        {
                            this.state.content.map((itm, i) => (
                                <div key={`${itm}-${i}`} className="marquee-content-itm" >
                                    {
                                        itm.viplevel != 0 && <img src={vipLevelImg[itm.viplevel]} className='xinxin' />
                                    }
                                    <div className='itemtextBox'
                                        style={{
                                            background: bgc[itm.viplevel],
                                            marginLeft: itm.viplevel == 0 ? 0 : 15,
                                            paddingLeft: itm.viplevel == 0 ? 6 : 17,
                                            borderTopLeftRadius: itm.viplevel == 0 ? 50 : 0,
                                            borderBottomLeftRadius: itm.viplevel == 0 ? 50 : 0
                                        }
                                        }>{'欢迎 ' + itm.content + ' 进入房间'}</div>
                                </div>
                            ))
                        }
                    </div>
                </div>
            </div>
        )
    }
}


export default Marquee